export const InspectionStatus = {
	SCHEDULED: 'SCHEDULED',
	IN_PROGRESS: 'IN_PROGRESS',
	COMPLETED: 'COMPLETED',
} as const;

export type InspectionStatus = (typeof InspectionStatus)[keyof typeof InspectionStatus];

export type InspectionType = Partial<{
	id: string;
	title: string;
	assetId: string;
	reportNumber: string;
	isStandardInspection: boolean;
	type: string;
	status: InspectionStatus;
	inspectorName: string;
	startDate: string;
	endDate: string | null;
	completionDate: string | null;
	assessmentAndActions: string | null;
	remarks: string | null;
	damagesCount: number;
	filesCount: number;
	createdAt: string;
	updatedAt: string;
	deletedAt: string | null;
	createRequestId: string | null;
	updateRequestId: string | null;
	createdById: string | null;
	updatedById: string | null;
}>;
